import React, {lazy, Suspense} from 'react'

const PilgrimagePageLazy = lazy(() =>
    import('./PilgrimagePage')
)

const PilgrimagePage = props => (
    <Suspense fallback={null}>
        <PilgrimagePageLazy {...props} />
    </Suspense>
)

export default PilgrimagePage
